import "../JSONTools/JSONformatter.css";
import ToolHeader from "../../Components/ToolHeader";
import "./TextUtilities.css";
import { Row, Col, Button } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";

import { CharCountAPI } from "../../Services/APIService";
import { ReactComponent as CopyIcon } from "../../Icons/Copy.svg";
import { ReactComponent as DeleteIcon } from "../../Icons/Delete.svg";
import { ReactComponent as HashIcon } from "../../Icons/hash.svg";

const emptyCounts = {
    rawCharacterCount: 0,
    visibleCharacterCount: 0,
    characterWithoutSpacesCount: 0,
    characterWithoutWhitespaceCount: 0,
    wordCount: 0,
    sentenceCount: 0,
    paragraphCount: 0,
    lineCount: 0,
    processingTimeMs: 0
};

function Counters() {
    const [input, setInput] = useState("");
    const [counts, setCounts] = useState(emptyCounts);
    const [countError, setCountError] = useState("");
    const [hasCopied, setHasCopied] = useState(false);
    const countRequestId = useRef(0);
    const toolFav = { toolName: "Text Counter", Iconpath: "/FileCodeRaw.svg" };

    const counterstype = [
        { label: "WORDS", value: counts.wordCount },
        { label: "CHARACTERS", value: counts.rawCharacterCount },
        { label: "SENTENCES", value: counts.sentenceCount },
        { label: "PARAGRAPHS", value: counts.paragraphCount },
        { label: "LINES", value: counts.lineCount }
    ];

    

    

    const handleInputChange = (e) => {
        setInput(e.target.value);
    };

    useEffect(() => {
        const requestId = countRequestId.current + 1;
        countRequestId.current = requestId;

        if (!input) {
            setCounts(emptyCounts);
            setCountError("");
            return;
        }

        const timeoutId = setTimeout(async () => {
            try {
                const response = await CharCountAPI({ input });

                if (requestId === countRequestId.current) {
                    setCounts(response.data);
                    setCountError("");
                }
            } catch (error) {
                if (requestId === countRequestId.current) {
                    setCountError(error.message);
                }
            }
        }, 250);

        return () => clearTimeout(timeoutId);
    }, [input]);

    const copyInput = () => {
        navigator.clipboard.writeText(input);
        setHasCopied(true);
        setTimeout(() => setHasCopied(false), 2000);
    };

    return (
        <>
            <Col>
                <ToolHeader title="Text Counter" description="Live counts, reading time, and keyword density" toolFav={toolFav} />
                <Row >
                    <Col className='ActionButtons'>
                        {counterstype.map((counter) => (
                            <Button
                                key={counter.label}
                                type="button"
                                className="counter-btn"
                            >
                                <span>{counter.value}</span>
                                <span className="blue-text">{counter.label}</span>
                            </Button>))}
                    </Col>
                </Row>
                <Row>
                    <Col className="case-layout">
                        <div className="case-left">
                            <div className="tool-card" style={{ height: "498px" }}>
                                <div className="tool-header">
                                    <span>Input Text</span>
                                    <div className="tool-actions">
                                        <button type="button" onClick={copyInput}>
                                            <CopyIcon className="tool-icon" />
                                            {hasCopied ? "Copied !!" : "Copy"}
                                        </button>
                                        <button type="button" onClick={() => setInput("")}>
                                            <DeleteIcon className="tool-icon" />
                                            Clear
                                        </button>
                                    </div>
                                </div>
                                <textarea
                                    value={input}
                                    onChange={handleInputChange}
                                    placeholder="Type or paste your text here..."
                                    className="tool-textarea"
                                />
                            </div>
                        </div>
                        <div className="stats-card">
                            <div className="stats-header">
                                <HashIcon className="stats-plus" />
                                Input Text
                            </div>
                            <div className="stats-row">
                                <span>Raw Characters</span>
                                <span>{counts.rawCharacterCount}</span>
                            </div>
                            <div className="stats-row">
                                <span>Visible Characters</span>
                                <span>{counts.visibleCharacterCount}</span>
                            </div>
                            <div className="stats-row">
                                <span>Characters (no spaces)</span>
                                <span>{counts.characterWithoutSpacesCount}</span>
                            </div>
                            <div className="stats-row">
                                <span>Characters (no whitespace)</span>
                                <span>{counts.characterWithoutWhitespaceCount}</span>
                            </div>

                            <div className="stats-row">
                                <span>Words</span>
                                <span>{counts.wordCount}</span>
                            </div>
                            <div className="stats-row">
                                <span>Sentence</span>
                                <span>{counts.sentenceCount}</span>
                            </div>
                            <div className="stats-row">
                                <span>Paragraph</span>
                                <span>{counts.paragraphCount}</span>
                            </div>
                            {countError && (
                                <div className="stats-row">
                                    <span>API Error</span>
                                    <span>{countError}</span>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Col >
        </>
    );
}

export default Counters;
